/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelIntegrationDashboardConfig.ts    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/integration-dashboard-config";

export class AutogenModelIntegrationDashboardConfig<RowType extends ModelRow> extends Endpoint<RowType, RowIntegrationDashboardConfigFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowIntegrationDashboardConfig extends ModelRow<RowIntegrationDashboardConfigFields> {
	constructor(values?: Partial<RowIntegrationDashboardConfigFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowIntegrationDashboardConfigFields {
	category_name: string;
	check_is_active: boolean;
	company_id: string;
	control_table_name: string;
	id: string;
	image_name: string;
	image_url: string;
	layout_id: string;
	layout_path: string;
	layout_title: string;
	name: string;
	vendor_id: string;
}

